// store/index.js

import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import {authentication} from './authentication.module'
import {alert} from './alert.module'
import {loader} from './loader.module'
import {newOutreachReports} from './reports.module'
import {detailedReports} from './detailed-report.module'
import {getters, outreachReport, tableData} from '../_services'

Vue.use(Vuex)
export const store =
  new Vuex.Store({
    modules: {
      outreachReport,
      authentication,
      tableData,
      loader,
      detailedReports,
      getters,
      alert,
      newOutreachReports
    },
    plugins: [
      createPersistedState()
    ]
  })



// export default store



// WEBPACK FOOTER //
// ./src/store/index.js